export default "__VITE_ASSET__5442026b__"